import { IRootState } from 'app/shared/reducers';
import React from 'react';
import { useSelector } from 'react-redux';
import DOMPurify from 'dompurify';

import './step-message.scss';

const StepMessage = () => {

  const title = useSelector((state: IRootState) => state.step.title)

  return (
    <>
      {title &&
        <div className="stepMessage">
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title)}}/>
        </div>
      }
    </>
  );
};

export default StepMessage;
